var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2615",
    "data-name": "Group 2615",
    transform: "translate(-616 -213)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_544",
    "data-name": "Ellipse 544",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(616 213)",
    fill: "#e2eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bxs-envelope",
    d: "M24.605,4H4.512A2.512,2.512,0,0,0,2,6.512v15.07a2.512,2.512,0,0,0,2.512,2.512H24.605a2.512,2.512,0,0,0,2.512-2.512V6.512A2.512,2.512,0,0,0,24.605,4Zm0,5.9L14.559,16.6,4.512,9.9V6.885l10.047,6.7,10.047-6.7Z",
    transform: "translate(636.441 233.953)",
    fill: "#195cff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.6504de8afa58ed428827be9d0f8b3512.svg";
export { ForwardRef as ReactComponent };